import { Pipe, PipeTransform } from '@angular/core';
import { DsLibMainMenuRouterLinkArgs } from '../interfaces/ds-lib-main-menu-router-link-args.interface';
import { DsLibMainMenuLinkInterface } from '../interfaces/ds-lib-main-menu-link.interface';

@Pipe({
  name: 'dsLibMainMenuRouterLink',
})
export class DsLibMainMenuRouterLinkPipe implements PipeTransform {
  /**
   * Formats url to match routerLink, and replaces custom args.
   *
   * @param link the transformed link
   * @param args Optional router link args to replace inside the url
   * @returns DsLibCheckRightsInterface[]
   */
  public transform(link?: DsLibMainMenuLinkInterface, args?: DsLibMainMenuRouterLinkArgs): (number | string)[] {
    if (!link || !link.url || link.disabled) {
      return null;
    }
    let formattedUrl = link.url;
    if (args) {
      Object.keys(args).forEach((key) => {
        const replace = args[key];
        formattedUrl = formattedUrl.replace(`/{${key}}`, replace ? `/${replace}` : '');
      });
    }
    return formattedUrl.split('/');
  }
}
